import type { RouterListener } from './RouterListener';
import AnonymousRouteListener from './AnonymousRouteListener';
import SidebarClosingListener from './SidebarClosingListener';
import PasswordExpiredListener from './PasswordExpiredListener';
import HomeRouteListener from './HomeRouteListener';
import PermissionRouteListener from './PermissionRouteListener';

const listeners: RouterListener[] = [
    new AnonymousRouteListener(),
    new SidebarClosingListener(),
    new PasswordExpiredListener(),
    new HomeRouteListener(),
    new PermissionRouteListener(),
];

export default listeners;
